module.exports = __webpack_public_path__ + "img/menu_icon09.57cd7700.png";